import axios from 'axios'

import { removeAuthenticationClientSide, saveAuthentication } from './cookiesManagement'
import { getUserInfoFromStorage, setUserInfoInStorage } from './userInfo'
import { getAuthToken, getReferralToken, getUserToken } from './auth'

const setHeadersFromStore = () => {
    axios.interceptors.request.use(req => {
        const referralToken = getReferralToken()
        const authToken = getAuthToken()

        const backupRefCode = process.env.NEXT_PUBLIC_BACKUP_REF_CODE

        if (authToken) req.headers.Authorization = `Bearer ${authToken}`
        if (referralToken) req.headers['x-referral-token'] = referralToken

        if (referralToken) {
            req.headers['x-referral-token'] = referralToken
        } else if (backupRefCode) {
            req.headers['x-referral-token'] = backupRefCode
        }



        return req
    })
}

const requestWithoutAuthentication = async asyncRequestFn => {
    // Cache data
    const userToken = getUserToken()
    const userInfoDto = getUserInfoFromStorage()

    removeAuthenticationClientSide()
    setHeadersFromStore()
    const data = await asyncRequestFn()

    // Set cached data
    if (userToken) {
        saveAuthentication(userToken)
    }
    if (userInfoDto) {
        setUserInfoInStorage(userInfoDto)
    }

    return data
}

export { requestWithoutAuthentication, setHeadersFromStore }
